import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Zilliqa",
  "use": "icon-Zilliqa-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Zilliqa\">\n<g id=\"icon-Zilliqa_icon\">\n<g id=\"icon-Zilliqa_Frame\">\n<path id=\"icon-Zilliqa_Vector\" d=\"M37.8857 11H12.1143C10.3964 11 9 12.4135 9 14.1514V30.2007C9 31.9387 10.3964 33.3522 12.1143 33.3522H37.8857C39.6036 33.3522 41 31.9387 41 30.2007V14.1514C41 12.4135 39.6036 11 37.8857 11ZM12.1143 13.2933H37.8857C38.3536 13.2933 38.7357 13.6791 38.7357 14.1514V23.0361H31.5786L27.0679 15.6154L19.9143 25.4375L17.5393 23.0361H11.2643V14.1514C11.2643 13.6791 11.6464 13.2933 12.1143 13.2933V13.2933ZM37.8857 31.0625H12.1143C11.6464 31.0625 11.2643 30.6767 11.2643 30.2043V25.3293H16.6L20.1714 28.9459L26.8929 19.7115L30.3071 25.3293H38.7286V30.2007C38.7357 30.6767 38.3536 31.0625 37.8857 31.0625V31.0625ZM13.1071 38.7067H36.8964V41H13.1071V38.7067Z\" fill=\"#A1B4CC\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Zilliqa.svg
// module id = 1C1u
// module chunks = 103